import {createMuiTheme} from "@material-ui/core/styles";

export const styledTextarea = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            multiline: {
                padding: ".33em .75em",

            },
        },
        MuiFormControl: {
            root: {
                backgroundColor: "#ebebeb",
                borderRadius: ".25rem"

            }
        }
    },
})
